import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Skeleton, Box } from '@mui/material';

/**
 * ProtectedRoute component that guards routes requiring authentication.
 * Redirects unauthenticated users to home page and shows login modal.
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading skeleton while checking auth status
  if (loading) {
    return (
      <Box className="min-h-screen bg-[#FAFBFC] py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Skeleton variant="rectangular" height={60} className="rounded-lg mb-6" />
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
            <Skeleton variant="rectangular" height={300} className="rounded-lg" />
            <div className="lg:col-span-3">
              <Skeleton variant="rectangular" height={400} className="rounded-lg" />
            </div>
          </div>
        </div>
      </Box>
    );
  }

  // Redirect to home if not authenticated
  // Store the attempted URL so we can redirect after login
  if (!isAuthenticated) {
    // Navigate to home with state indicating login is required
    return (
      <Navigate 
        to="/" 
        state={{ 
          from: location.pathname,
          showLogin: true,
          message: 'Please sign in to access this page' 
        }} 
        replace 
      />
    );
  }

  return children;
};

export default ProtectedRoute;
